import { render, staticRenderFns } from "./IconoEstadoInactivo.vue?vue&type=template&id=361fa828&"
import script from "./IconoEstadoInactivo.vue?vue&type=script&lang=js&"
export * from "./IconoEstadoInactivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports